import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

// eslint-disable-next-line arrow-body-style
const TheContextPrivateCredit = () => {
  return (
    <>
      {/* members */}
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          display="flex"
          as="section"
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDirection="column"
        >
          <Flex
            alignItems={{ xs: 'flex-start', md: 'flex-start' }}
            justifyContent="center"
            columnGap="24px"
            justifyItems="center"
            width="100%"
            display="flex"
            as="section"
            rowGap="30px"
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
          >
            <Flex flexDir="column" rowGap="16px">
              <Heading
                color="white"
                fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
                fontWeight="800"
                lineHeight={{ xs: '35px', lg: '83px' }}
              >
                #TheContext
              </Heading>
            </Flex>
            <Box
              w="1.5px"
              h={{ xs: '100%' }}
              bgColor="white"
              display={{ xs: 'none', md: 'block' }}
            />
            <Box
              w={{ xs: '70%', sm: '60%' }}
              h="1.5px"
              bgColor="white"
              display={{ xs: 'block', md: 'none' }}
            />
            {/*  */}
            <Heading
              as="h1"
              mb={{ xs: '10px', md: '20px' }}
              variant="reportCardTitle"
              fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '38px' }}
              color="white"
              lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '62px' }}
            >
              Private Credit: Expanding from Niche to Norm in India
            </Heading>
          </Flex>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        pt="40px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Box
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '40px' }}
          mb="20px"
        >
          <Flex
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
            gap="20px"
            alignItems={{
              xs: 'center',
              md: 'unset',
            }}
          >
            <Img
              src="https://static.levocdn.com/WGLBUT82/Screenshot2025-02-07at61519PM-c2u8areyKfbb.png"
              alt="Monu Jain
"
              width="250px"
              height="250px"
              objectFit="cover"
              borderRadius="50%"
            />
            <Flex direction="column">
              <Heading
                as="h1"
                fontWeight="800"
                pt="20px"
                variant="reportCardTitle"
                fontSize={{ xs: '16px', md: '18px', lg: '20px' }}
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Monu Jain
                <Link
                  href="https://www.linkedin.com/in/monu-jain-58335a/"
                  target="_blank"
                  display={{ xs: 'inline-block', md: 'none' }}
                  pl="10px"
                >
                  <IconButton
                    aria-label="linkedin"
                    icon={<FaLinkedin size="28px" color="#067acc" />}
                    variant="unstyled"
                    cursor="pointer"
                  />
                </Link>
              </Heading>
              <Text
                color="text.mediumBlack"
                maxW={{
                  xs: '100%',
                  md: '120px',
                }}
                w="100%"
                fontSize="16px"
                lineHeight="22px"
                fontStyle="italic"
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Partner, Aavishkaar Capital
              </Text>

              <Link
                href="https://www.linkedin.com/in/monu-jain-58335a/"
                target="_blank"
                display={{
                  xs: 'none',
                  md: 'block',
                }}
              >
                <IconButton
                  aria-label="linkedin"
                  icon={<FaLinkedin size="28px" color="#067acc" />}
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Box mt="16px" mb="20px">
            <Text variant="blogAnswer">
              The private credit landscape in India is experiencing a dynamic
              transformation, evolving from a niche sector into a mainstream
              financial solution that caters to a wide array of borrowing needs.
              Over the past decade, private credit investments have grown
              significantly, accounting for approximately 9% of all alternative
              capital investments, amounting to around US $36 billion. In 2024
              alone, credit investments accounted for approximately 17% of total
              investments, highlighting the market's rapid growth. <br /> <br />
              Several factors are driving this unprecedented expansion. One of
              the key demand drivers is the increasing need for flexible
              financing options among businesses, particularly small and
              medium-sized enterprises (SMEs). Traditional banking channels
              often impose stringent requirements and rigid assessment criteria,
              making private credit an attractive alternative for companies
              seeking quick and customized financing solutions. Additionally,
              the rise of new-age industries and the entrepreneurial ecosystem
              has further fueled the demand for private credit. <br /> <br />
              Innovative deal structures have played a crucial role in the
              growth of private credit in India. Structured credit products,
              mezzanine financing, and hybrid instruments have gained
              popularity, offering investors a wide range of investment options
              with varying risk-return profiles. These innovative structures
              have enabled borrowers to access capital tailored to their
              specific needs, whether it's for expansion, working capital, or
              debt refinancing. <br /> <br />
              The expanding pool of investors is another significant factor
              contributing to the growth of private credit. Ultra-high-net-worth
              individuals (UHNIs), family offices, domestic institutional
              investors, and global funds have shown increased interest in the
              sector. The attractive risk-adjusted returns, coupled with the
              diversification benefits of private credit, have made it a
              compelling asset class for a diverse group of investors. <br />{' '}
              <br />
              Regulatory oversight and policy changes have also played a pivotal
              role in shaping the private credit landscape in India. The
              introduction of measures to enhance transparency, protect investor
              interests, and promote responsible lending practices has instilled
              confidence in the market. The regulators efforts to regulate and
              monitor the sector have provided a stable framework for the growth
              of private credit. However, there is still room for improvement,
              with ongoing discussions around more enabling regulations and
              creating a more conducive environment for private credit
              investments. <br /> <br />
              As the sector continues to evolve, the panel discussion will delve
              into various aspects of the private credit landscape. Looking
              forward to exchanging insights from personal experiences in the
              credit journey around opportunities and challenges in Private
              Credit... Impact fund managers such as Aavishkaar Capital view
              private credit in India is a huge opportunity to channelise
              investments into projects and enterprises that generate positive
              social and environmental outcomes alongside financial returns. By
              providing much-needed capital to these sectors, we are enabling
              businesses to expand and innovate, ultimately driving the growth
              of private credit. <br /> <br />
              Furthermore, we at Aavishkaar Capital have brought innovative
              financing structures to the forefront, blending traditional
              financial instruments with impact-oriented goals. By utilizing
              blended finance, where concessional capital is combined with
              commercial capital to de-risk investments and attract more private
              sector participation, our approach has not only increased the flow
              of capital into underserved sectors but also enhanced the overall
              credibility and attractiveness of private credit as an asset
              class. By demonstrating that investments can achieve both
              financial returns and positive societal outcomes, we continue to
              play a crucial role in reshaping the private credit landscape in
              India. In conclusion, private credit in India is no longer a niche
              segment but a burgeoning sector poised for continued growth. With
              favorable demand drivers, innovative financing structures, an
              expanding investor base, and supportive regulatory measures, the
              future of private credit in India looks promising.
            </Text>
          </Box>
        </Box>

        <Box width="100%" height="2px" bgColor="primary.200" />
        <Text
          variant="blogAnswer"
          lineHeight="30px"
          pt="18px"
          fontStyle="italic"
          p="12px 12px 0px"
          fontWeight="500"
        >
          <Text as="span" fontWeight="700" fontStyle="normal">
            #TheContext by IVCA
          </Text>{' '}
          – features opinion makers from the alternate investing industry with
          strong focus on India as an investment destination. Watch this space
          for new announcements in the sector, viewpoints on investment themes,
          emerging trends, economic reports, analysis and latest industry
          insights.
        </Text>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          Content in this section is curated by team IVCA. To share feedback,
          connect with&nbsp;
          {/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default TheContextPrivateCredit;
